<template>
      <div >
        <div>
    <vue-hcaptcha
    data-sitekey="2bcb4ab8-e5db-44ea-ab84-ab428b0a1936"
    @verify="callback ()"
    @expired="error()"
    @error="error()"
    ></vue-hcaptcha></div>
    <!-- <div class="row">
     <ul v-if="rers.length" >
        <li v-for="error in rers" :key="error"  style="color:red">{{error}}</li></ul>
        </div> -->
  </div>
</template>

<script >
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

export default ({
  nome: 'captcha',
  components: { VueHcaptcha },

  data () {
    return {
      risposta: !window.hcaptcha.getResponse(),
      compila: false,
      rers: []
    }
  },
  methods: {

    validateCaptcha () {
      console.log('response')
      this.risposta = window.hcaptcha.getResponse()
      console.log(this.risposta)
    },

    exeCaptcha () {
      const risp = window.hcaptcha.getResponse()
      console.log('exe ')
      if (this.risposta === risp) {
        console.log('verify')
        this.$emit('verify')
      } else {
        this.error()
      }
    },
    callback () {
      console.log('response')
      this.risposta = window.hcaptcha.getResponse()
      console.log(this.risposta)
    },
    error () {
      // window.hcaptcha.execute()
      this.rers = []
      this.rers.push('compila captcha')
      console.log(this.rers)
    }

  }

})

</script>
